import { h } from 'preact';
import { useEffect, useRef } from 'preact/compat';

import { window } from '../src/env/browser';

import useCreateAppConfig from './use-create-app-config';
import {
  containerStyle,
  iframeStyle,
  MICRO_APP_STARTUP_MESSAGE,
  MICRO_APP_URL,
} from './constants';

const LegacyApp = ({ deps }, otherProps) => {
  /**
   * this is experimental prop reading from internal preact object
   * it can be broken with another version of preact
   */
  // eslint-disable-next-line no-underscore-dangle
  const APP_NAME = otherProps.__cC10.props.value.matches[0].params.appName;
  const iframeRef = useRef(null);
  const { isLoading, config } = useCreateAppConfig(APP_NAME, deps);

  useEffect(
    () => {
      if (iframeRef.current && !isLoading) {
        setTimeout(() => {
          window.Shore.microAppArgs[APP_NAME] = config;
          iframeRef.current.contentWindow.postMessage(
            { type: MICRO_APP_STARTUP_MESSAGE },
            '*',
          );
        }, 1000);
      }
    },
    [iframeRef.current, isLoading],
  );

  return (
    <div style={containerStyle}>
      <iframe ref={iframeRef} style={iframeStyle} src={MICRO_APP_URL} />
    </div>
  );
};

export default LegacyApp;
